import cn from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import menuIcon from "../../assets/icons/menu.png";
import logoLite from "../../assets/images/recomposer-lite.png";
import logo from "../../assets/images/recomposerapp.png";
import { ENDUSER_COMPANY } from "../../constants/common";
import { AUTH } from "../../constants/router";
import { setShowMenu } from "../../redux/windowSlice";
import "./Header.scss";

export const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.user.user);
  const showMenu = useSelector((state) => state.window.showMenu);

  const companyId = 1; // TODO: получать из redux  //const { companyId } = useSelector(state => ...)
  const isEndUserClient = companyId === ENDUSER_COMPANY.ID;
  const authorized = !!user;
  const isEndUser = user?.is_end_user;
  const firstLogin =
    isEndUser && (!user?.is_strength_exists || !user?.is_program_exists);
  const hideMenu = firstLogin || !authorized;
  const showRecomposerLiteLogo = isEndUser || !authorized;
  const isAuthPage = location.pathname === AUTH.root;
  const toggleMenu = () => {
    document.body.style.overflow = "hidden";
    dispatch(setShowMenu(true));
  };

  const logoSrc = isEndUserClient || showRecomposerLiteLogo ? logoLite : logo;

  return (
    <div>
      {!isAuthPage && (
        <header id="main-header" className="main-header">
          {!showMenu && !hideMenu && (
            <img
              alt="Menu icon"
              className="main-header__menu"
              onClick={toggleMenu}
              src={menuIcon}
            />
          )}
          {user && (
            <>
              <img
                alt="Logo"
                className={cn("main-header__logo", {
                  lite: showRecomposerLiteLogo,
                })}
                src={logoSrc}
              />
              <div className="main-header__version">v3</div>
            </>
          )}
        </header>
      )}
    </div>
  );
};
